import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { 
  LockOutlined as LockOutlinedIcon 
} from '@mui/icons-material'
import {
  Box,
  Typography,
  Container,
  Avatar,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Grid,
  Link,
} from '@mui/material'

import {
  setFlashNotice,
  setFlashAlert,
  clearFlashNotice,
  clearFlashAlert
} from '../ui/uiSlice'
import { loadUserData, selectAuthToken, setAuthToken } from './userSlice'
import { fetchPagesAsync } from '../pages/pagesSlice'
import { fetchSharesAsync } from '../shares/sharesSlice'
import { formatDeviseErrors } from '../../../components/devise/deviseErrors'
import { deviseFetch, showFailedRequest } from '../../../components/devise/deviseRequest'
import useSubmitting from '../../../hooks/useSubmitting'

const classes = {
}

export default function SignIn() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const storedAuthToken = useSelector(selectAuthToken)
  const csrfToken = storedAuthToken || document.querySelector('meta[name=csrf-token]')?.content || ''

  const [rememberMe, setRememberMe] = useState(false)
  const [submitting, submit] = useSubmitting()

  useEffect(() => {
    if (!storedAuthToken) {
      const documentAuthToken = document.querySelector('meta[name=csrf-token]')?.content
      if (documentAuthToken) {
        dispatch(setAuthToken(documentAuthToken))
      }
    }
  }, [dispatch, storedAuthToken])

  const handleSubmit = (evt) => {
    evt.preventDefault()

    // setErrors({})
    dispatch(clearFlashNotice())
    dispatch(clearFlashAlert())

    const data = new FormData(evt.currentTarget)
    const csrfToken = storedAuthToken || document.querySelector('meta[name=csrf-token]')?.content || ''
    if (csrfToken) {
      data.set('authenticity_token', csrfToken)
    }
    for (let pair of data.entries()){
      console.log(pair[0], pair[1])
    }

    submit(async () => {
      const result = await deviseFetch(dispatch, "/user/sign_in.json", {
        method: 'post',
        body: data,
        headers: {
          "Accept": "application/json",
          ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
        }
      })

      if (result.failure) {
        showFailedRequest(dispatch, result)
        return
      }
      const { response, json: json_data } = result

      console.log(response.status)
      console.log(json_data)

      if (response.status === 201){
        console.log('signed in')
        // dispatch(setFlashNotice(json_data.message))

        // Promote authenticated state before navigation so route guards switch
        // from unauthenticated routes to authenticated routes.
        dispatch(loadUserData(json_data))
        await dispatch(fetchPagesAsync())
        await dispatch(fetchSharesAsync())

        // Set the flash straight before navigating (not before the await above),
        // or clearing flashes on navigation would remove it.
        dispatch(setFlashNotice('Signed in successfully.'))

        // TODO: The address of the last page should be in the json.
        const lastPageId = json_data?.user?.last_page_id
        navigate(lastPageId ? `/app/pages/${lastPageId}` : '/app/pages')

        return

      }
      else if (response.status === 401 ) {
        // Process unsuccessful login
        console.log('Unsuccessful login')
        dispatch(setFlashAlert(formatDeviseErrors(json_data)))

        return
      }

      // Otherwise, it is an unexpected response (say a 500 page): say so.
      dispatch(setFlashAlert(formatDeviseErrors(json_data)))
    })
  }

  const handleCheckClick = (evt) => {
    setRememberMe(!rememberMe)
    // console.log(evt.currentTarget)
  }

  const handleNavClick = (e) => {
    let path = e.currentTarget.href.replace(/https?\:\/\//, '')
      .replace(e.currentTarget.host, '')
    navigate(path)
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 9,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>

        <Typography component='h1' variant='h5'>
          Sign in
        </Typography>
        <Box 
          component="form" 
          // action="/user/sign_in"
          method="post"
          sx={{ mt: 1, width: '100%', maxWidth: 400 }}
          onSubmit={handleSubmit} 
          noValidate
        >
          <TextField
            margin='normal'
            required
            fullWidth
            id='user[login]'
            label='Login'
            name='user[login]'
            autoComplete='login'
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="user[password]"
            label="Password"
            type="password"
            id="user[password]"
            autoComplete="password"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                color="primary" 
                id="remember"
                onClick={handleCheckClick} 
              />}
            label="Remember me"
          />
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <input type="hidden" name="commit" value="Log in" />
          <input type="hidden" name="user[remember_me]" value={rememberMe ? 1: 0} />
          {/* <button type="submit">Sign in</button> */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            loading={submitting}
            sx={{ mt: 3, mb: 2 }}
          >
            Sign in
          </Button>
          <Grid container>
            <Grid sx={{ flexGrow: 1 }}>
              <Link
                onClick={handleNavClick}
                href="/app/reset_password"
                variant="body2"
                >
                Problems signing in?
              </Link>
            </Grid>
            <Grid>
              <Link 
                onClick={handleNavClick}
                href="/app/sign_up"
                variant="body2"
                >
                Don't have an account? Sign Up
              </Link>
            </Grid>
          </Grid>            
        </Box>
      </Box>
    </Container>
  )
}
